import {  USBColumn } from '@usb-shield/react-grid/dist/esm';
import {Cell} from '@usb-ui-tools/react-billpay-cell'
import { CommonLayoutProps } from 'lib';
import PropTypes from 'prop-types';
import React from 'react';
import {} from '@usb-ui-tools/react-billpay-theme'
const AsideLayout = ({children, showFrame=false, ...otherProps}:CommonLayoutProps) =>{
    return(
        <USBColumn
         layoutOpts={{
            spans: {
              xlarge: 4,
              large: 4,
              medium: 3,
              small: 4
            },
            offset: {
              xlarge: 12,
              large: 12,
              medium: 5
            }
          }} {...otherProps}>
            {showFrame ? <Cell removeFlex styles={{ marginRight:'-2rem'}}  tagName={'div'}>{children}</Cell> : <>{children}</>}
        </USBColumn>
    )
}
export default AsideLayout;

AsideLayout.propTypes = {
    children: PropTypes.node.isRequired,
    otherProps: PropTypes.any
  };
  AsideLayout.defaultProps = {
    otherProps:{}
  };